<template>
  <div>
    <MovieList :movies="dorms" v-if="dorms"/>
    <FixedPopup :dorms="popupDorms" v-if="popupDorms && popupDorms.length > 0"/>
  </div>
</template>

<script>
import MovieList from '@/components/MovieList'
import FixedPopup from '@/components/FixedPopup'
import axios from 'axios'

export default {
  name: 'CityDistrictGender',
  components: {
    MovieList,
    FixedPopup
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.pageTitle,
      meta: [
        { vmid: 'description', name: 'description', content: this.pageDescription },
        { vmid: 'keywords', name: 'keywords', content: this.pageKeywords }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.url }
      ]
    }
  },
  data () {
    return {
      url: '',
      dorms: null,
      popupDorms: null,
      errors: [],
      gender: '',
      typeID: null,
      district: null
    }
  },
  methods: {
    checkGender () {
      const type = this.$attrs.redirect ? this.$route.params.slug : this.$route.params.type
      if (type && type.includes('erkek')) {
        this.gender = 'Erkek'
        this.typeID = 1
      } else if (type && type.includes('kiz')) {
        this.gender = 'Kız'
        this.typeID = 2
      }
    },
    getDorms () {
      this.checkGender()
      let self = this
      axios.get(`/site/cities/dorms/${this.$route.params.city}?district=${this.$route.params.district}&dorm_type=${self.typeID}`)
        .then(response => {
          self.dorms = response.data.data.data
          self.district = response.data.district
          self.popupDorms = response.data.popups
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  },
  computed: {
    pageTitle () {
      let title = ''
      if (this.district) {
        if (this.typeID === 1) title = this.district.male_title
        else if (this.typeID === 2) title = this.district.female_title
      }
      return title
    },
    pageDescription () {
      let title = ''
      if (this.district) {
        if (this.typeID === 1) title = this.district.male_description
        else if (this.typeID === 2) title = this.district.female_description
      }
      return title
    },
    pageKeywords () {
      let title = ''
      if (this.district) {
        if (this.typeID === 1) title = this.district.male_keywords
        else if (this.typeID === 2) title = this.district.female_keywords
      }
      return title
    }
  },
  created () {
    this.getDorms()
    this.url = window.location.origin + '/' + this.$route.params.city + '-movies/'
  },
  watch: {
    $route () {
      this.getDorms()
    }
  }
}
</script>

<style lang="scss">
</style>
